var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMyCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0125 15C20.2013 15 21 16.1175 21 17.16C21 19.2713 17.685 21 17.625 21C17.565 21 14.25 19.2713 14.25 17.16C14.25 16.1175 15.0488 15 16.2375 15C16.92 15 17.3663 15.3413 17.625 15.6413C17.8837 15.3413 18.33 15 19.0125 15Z",
    fill: "#F7DE2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3332 14.5733H9.46651C8.24856 14.5733 7.63958 14.5763 7.14405 14.7267C6.02836 15.0651 5.15527 15.9376 4.81682 17.0533C4.6665 17.5489 4.6665 18.7821 4.6665 20M15.5756 7.92727C15.5756 10.0962 13.8173 11.8545 11.6483 11.8545C9.47935 11.8545 7.72105 10.0962 7.72105 7.92727C7.72105 5.7583 9.47935 4 11.6483 4C13.8173 4 15.5756 5.7583 15.5756 7.92727Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyCommunity);
export default __webpack_public_path__ + "static/media/icon_my_community.605b7c649665646662bcbfb429cc6d54.svg";
export { ForwardRef as ReactComponent };